import { format } from "date-fns";

export const toUTC = (localTime: string): string => {
  const [hours, minutes] = localTime.split(":").map(Number);   // Split the local time to extract hours and minutes
  const date = new Date(1970, 0, 1, hours, minutes); // No timezone conversion
  const offset = date.getTimezoneOffset(); // Offset in minutes
  const utcDate = new Date(date.getTime() + offset * 60 * 1000); // Adjust the date to UTC
  const result = format(utcDate, "HH:mm:ss"); // Format the UTC date
  return result;
};

// Function to convert UTC to local time
export const fromUTC = (utcTime: string): string => {
   
    if (!utcTime || typeof utcTime !== 'string') {
        console.error("Invalid UTC time input:", utcTime);
        return "00:00";
    }
    
    try {
        // Remove the timezone offset if present
        const timeOnly = utcTime.split('+')[0];
        const date = new Date(`1970-01-01T${timeOnly}Z`);
        const result = format(date, "HH:mm");
        return result;
    } catch (error) {
        console.error("Error converting UTC time:", error);
        console.error("Problematic input:", utcTime);
        return "00:00";
    }
}; 
